<script>
    import SidebarLink from './SidebarLink'
    import { collapsed, toggleSidebar, sidebarWidth } from './state'

    export default {
        props: {},
        components: { SidebarLink },
        setup() {
            return { collapsed, toggleSidebar, sidebarWidth }
        },
        data() {
            return {
                videoModalVisible: false, // Controls modal visibility
                videoSrc: '',             // Holds the current video URL
                isRestricted: false,
                newBlog: false,
                isDev: process.env.NODE_ENV !== 'production'
            };
        },
        mounted() {
            window.addEventListener("resize", this.widthChanged);
            window.addEventListener('refresh-subscription-status', this.handleRefreshEvent)

            this.widthChanged();
            this.handleRefreshEvent();
        },
        unmounted() {
            window.removeEventListener("resize", this.widthChanged);
            window.removeEventListener('refresh-subscription-status', this.handleRefreshEvent);
        },
        methods: {
            handleRefreshEvent() {
                this.isRestricted = !window.$core.data.UserInfo.Metadata?.IsRestricted;
                this.newBlog = window.$core.data.UserInfo.Metadata?.UnreadBlog > 0;
            },
            widthChanged(e) {
                if (window.innerWidth < 767) {
                    this.collapsed = true;
                } else {
                    this.collapsed = false;
                }
            },
            showVideo(videoUrl) {
                this.videoSrc = videoUrl; // Set the video source
                this.videoModalVisible = true; // Show the modal

                this.$nextTick(() => {
                    // Automatically play the video once the modal is opened
                    this.$refs.videoPlayer.play();
                });
            },
            onVideoEnd() {
                // Optionally handle the event when the video ends
                console.log("Video has ended");
            },
            signOut() {
                window.$core.clearStorage();
                window.$router.push('/login');
            }
        }
    }
</script>

<template>
    <div class="sidebar" :style="{ width: sidebarWidth }">
        <div style="background-color: white; margin: -0.5em;">
            <div @click="collapsed=!collapsed" style="margin: .5em;"><i class="material-icons">menu</i></div>

            <a v-if="!collapsed" href="/" style="margin: .5em;" class="relative">
                <img src="/logo.png" style="max-width:180px; margin: 0px 0 17px 15px" />
                <img v-if="isDev" src="@/assets/img/beta-icon2.png" alt="Beta Version" style="height:45px;position:absolute;right:-5px;top:-20px;" />
            </a>
        </div>
        <div v-if="!collapsed" style="margin-top: 1em; display: none;">

            <div class="how-to-use" @click="showVideo(require('@/assets/videos/What_Is_GC_Buddy.mp4'))">How to use Contractly.ca</div>
        </div>

        <SidebarLink to="/MyProfile/0" style="margin-top: 1em;" icon="material-icons" word="person">My Profile</SidebarLink>
        <SidebarLink to="/MyProjects" icon="material-icons" word="home_repair_service">My Projects/Clients</SidebarLink>
        <SidebarLink to="/UploadFile" icon="material-icons" word="cloud_upload">Upload Contract</SidebarLink>

        <SidebarLink to="/ContractTemplate" icon="material-icons" word="text_snippet">Contract Templates</SidebarLink>

        <SidebarLink to="/MyContacts" icon="material-icons" word="person">My Contacts</SidebarLink>
    
        <SidebarLink to="/Settings" icon="material-icons" word="settings">Log-In Settings</SidebarLink>


        <SidebarLink to="/Subscription" icon="material-icons" word="credit_card">
            <div style="display: flex; align-items: center;align-self: center;">Subscription 
                <i class="material-icons" v-if="!isRestricted" style="color:red; font-size: 16px;">info</i>
            </div>
            
            
        </SidebarLink>

        <SidebarLink to="/HowToUse" icon="material-icons" word="play_circle">How To Use Contractly</SidebarLink>

        <SidebarLink to="/InnerBlog" icon="material-icons" word="blog">
            <div style="display: flex; align-items: center;align-self: center;">Blog 
                <span v-if="newBlog" class="new-blog"> NEW</span>
            </div>
        </SidebarLink>

        <SidebarLink to="/"  icon="material-icons" word="logout" @click="signOut">Sign Out</SidebarLink>
        <span class="collapse-icon" :class="{ 'rotate-180': collapsed }" @click="toggleSidebar">
            <i class="fas fa-angle-double-left" />
        </span>
        <!-- Video Modal -->
        <n-modal v-model:show="videoModalVisible" style="width: 80vw;" preset="card" size="large">
            <video ref="videoPlayer"
                   :src="videoSrc"
                   controls
                   style="width: 100%; height: auto;"
                   @ended="onVideoEnd"></video>
        </n-modal>
    </div>

  
</template>

<style>
    :root {
        --sidebar-bg-color: #71b18f;
        --sidebar-item-hover: #4b8365;
        --sidebar-item-active: #4b8365;
    }
</style>

<style scoped>
    .sidebar {
        color: white;
        background-color: var(--sidebar-bg-color);
        float: left;
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        bottom: 0;
        padding: 0.5em;
        transition: 0.3s ease;
        display: flex;
        flex-direction: column;
    }

        .sidebar h1 {
            height: 2.5em;
        }

    .collapse-icon {
        position: absolute;
        bottom: 0;
        padding: 0.75em;
        color: rgba(255, 255, 255, 0.7);
        transition: 0.2s linear;
    }

    .rotate-180 {
        transform: rotate(180deg);
        transition: 0.2s linear;
    }

    .how-to-use{color:red;text-decoration:underline; text-align:center;font-size: 12px; cursor:pointer; margin: 8px;}
    .new-blog{background-color: red;
             color: white;
             font-size: 10px;
             font-weight: bold;
             border-radius: 4px;
             padding: 2px 6px;
             margin-left: 8px;
             text-transform: uppercase;
             animation: pulse 1.5s infinite;
            }

    @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.1); opacity: 0.7; }
        100% { transform: scale(1); opacity: 1; }
    }
</style>
